module.exports = __webpack_public_path__ + "img/stella-3.e07c13c.jpg";